import { IStatusMessage } from '../../../shared';
import { DataServiceEntity } from '../../data-service.entity';
export interface ValidationMessageModel {
    dataColumnIndex: number;
    dataReference: string;
    dataRowIndex: number;
    messageText: string;
    severity: string;
}
export interface PayrollExportModel
    extends DataServiceEntity<PayrollExportModel> {
    id: string | number;
    PayPeriodEndDate: Date;
    SentDate?: Date;
    SentBy?: string;
    ExportStatus: string;
    ValidationMessages: ValidationMessageModel[];
    Status: IStatusMessage;
}
export enum PayrollExportStatus {
    Parsing = 'Parsing',
    ParsingComplete = 'ParsingComplete',
    ParsingCompleteWithErrors = 'ParsingCompleteWithErrors',
    Importing = 'Importing',
    ImportingComplete = 'ImportingComplete',
    Refreshing = 'Refreshing'
}
export enum PayrollExportErrorStatuses {
    ParsingCompleteWithErrors = 'ParsingCompleteWithErrors'
}
// This should be a subset of the above enum
export enum PayrollExportCompletedStatuses {
    // ParsingComplete = 'ParsingComplete',
    ParsingCompleteWithErrors = 'ParsingCompleteWithErrors',
    ImportingComplete = 'ImportingComplete'
}
export enum PayrollExportCompletedSuccessStatuses {
    ImportingComplete = 'ImportingComplete'
}

export enum PayrollExportInProgressStatuses {
    Parsing = 'Parsing',
    Importing = 'Importing',
    Refreshing = 'Refreshing'
}
